// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3axzr","sendOtp":"AuthorizeToLogin_sendOtp__UHPgK"};